/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * authorizationUrl:授权域名
 * xlogUrl:xlog域名
 * routerMode: 路由模式  history  hash
 * wxjsurl: 引入微信js文件
 * imgBaseUrl: 图片所在域名地址
 *
 */
let baseUrl;
let hostUrl;
let gxHostUrl
let ys_baseUrl;  //有书豆相关项目的域名
let baseUrlReadoo;   //红包详情
let baseUrlstudy;    //3.4学习页
let authorizationUrl;
let xlogUrl;
let routerMode;
let pro_name;
const wxjsurl = 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js';
const imgBaseUrl = '';
let envId;                      //环境变量(测试、正式)
let npm_env;
let readoo_host;
let order;
let wechat_id;
let appid;
let mobileLoginUrl;
let scUrl = '';
let isYzgx = location.host.indexOf('yzgx') > -1 ||location.host.indexOf('dengjiawu') > -1 || location.host.indexOf('youshucs') > -1
// 元知国学苑 206 wxcefda863f201c869
// 海豚写作 49 wx9ad1ad8dda111347
// 有书共读 5 wx17642efccac31518
if (process.env.NODE_ENV == 'development') {

    baseUrl = 'http://gongdu.laidan.com';
    ys_baseUrl = 'http://ysreadoo.laidan.com'; //有书豆项目相关的域名
    baseUrlReadoo = 'http://gongdu.laidan.com';
    order = 'http://gongdu.laidan.com';
    baseUrlstudy = 'http://gongdu.laidan.com';
    hostUrl='http://m.laidan.com';
    gxHostUrl = 'http://zwds.dengjiawu.com';
    readoo_host = 'http://ysreadoo.laidan.com';
    authorizationUrl='http://ysreadoo.laidan.com';
    xlogUrl='https://xlog.laidan.com';
	routerMode = 'history';
    envId = 0;
    mobileLoginUrl = 'http://p.laidan.com';
    npm_env = 'zaia';
    wechat_id = isYzgx ? 49 : 23;
    appid = isYzgx ? 'wx9ad1ad8dda111347' : 'wxa54f7d0b12e62533';
    pro_name = 'rd_classroom_yz'
    scUrl = 'http://rwshopdev.laidan.com';
}else {
    switch (process.env.VUE_APP_WEB_ENV) {
        case 'qa':             //qa测试环境
            //测试
            baseUrl = 'https://qa-gongdu.laidan.com';
            ys_baseUrl = 'https://qa-ysreadoo.laidan.com'; //测试环境上有书豆相关项目的域名
            baseUrlReadoo= 'https://qa-gongdu.laidan.com';   //红包详情
            baseUrlstudy = 'https://qa-gongdu.laidan.com';
            authorizationUrl='https://qa-ysreadoo.laidan.com';
            xlogUrl='https://qa-xlog.laidan.com';
            hostUrl='https://qa-m.laidan.com';
            gxHostUrl = 'https://qa-zwds.dengjiawu.com';
            readoo_host = 'https://qa-ysreadoo.laidan.com';
            envId = 0;
            mobileLoginUrl = 'https://qa-p.laidan.com';
            npm_env = 'qa';
            wechat_id = isYzgx ? 49 : 99;
            appid = isYzgx ? 'wx9ad1ad8dda111347' : 'wx839cbdef7d937a7c';
            pro_name = 'qa_classroom_yz';
            scUrl = 'https://qa-rwshopdev.laidan.com';
            break;
        case 'zaia':             //zaia测试环境
            //测试
            baseUrl = 'https://gongdu.laidan.com';
            ys_baseUrl = 'https://ysreadoo.laidan.com'; //测试环境上有书豆相关项目的域名
            baseUrlReadoo= 'https://gongdu.laidan.com';   //红包详情
            order= 'https://gongdu.laidan.com';   //红包详情
            baseUrlstudy = 'https://gongdu.laidan.com';
            authorizationUrl='https://ysreadoo.laidan.com';
            xlogUrl='https://xlog.laidan.com';
            hostUrl='https://m.laidan.com';
            gxHostUrl = 'https://zwds.dengjiawu.com';
            readoo_host = 'https://ysreadoo.laidan.com';
            envId = 0;
            mobileLoginUrl = 'https://p.laidan.com';
            npm_env = 'zaia';
            wechat_id = isYzgx ? 49 : 23;
            appid = isYzgx ? 'wx9ad1ad8dda111347' : 'wxa54f7d0b12e62533';
            pro_name = 'rd_classroom_yz'
            scUrl = 'https://rwshopdev.laidan.com';
            break;
        case 'luoluo':         //luoluo测试
            //正式
            baseUrl = 'https://gongdu.youshu.cc';
            ys_baseUrl = 'https://readooapi.youshu.cc';
            baseUrlReadoo = 'https://readooapi.youshu.cc';
            baseUrlstudy = 'https://gongdu.youshu.cc';
            order = 'https://gongdu.youshu.cc';
            hostUrl='https://m.youshu.cc';
            gxHostUrl = 'https://m.youshucs.com';
            readoo_host = 'https://lax.sanzijing.net'
            authorizationUrl='https://readooapi.youshu.cc';
            xlogUrl='https://xlog.youshu.cc';
            envId = 0;
            mobileLoginUrl = 'https://m.youshu.cc';
            npm_env = 'luoluo';
            wechat_id = isYzgx ? 206 : 5;
            appid = isYzgx ? 'wx801ff794f6a7c4d5' : 'wx17642efccac31518';
            pro_name = 'classroom_yz';
            scUrl = 'https://sc.youshu.cc';
            break;
        case 'prod':         //readoo生产环境
            //正式
            baseUrl = 'https://gongdu.youshu.cc';
            ys_baseUrl = 'https://readooapi.youshu.cc';
            baseUrlReadoo = 'https://readooapi.youshu.cc';
            baseUrlstudy = 'https://gongdu.youshu.cc';
            order = 'https://gongdu.youshu.cc';
            hostUrl='https://m.youshu.cc';
            gxHostUrl = 'https://m.youshucs.com';
            readoo_host = 'https://lax.sanzijing.net'
            authorizationUrl='https://readooapi.youshu.cc';
            xlogUrl='https://xlog.youshu.cc';
            envId = 1;
            mobileLoginUrl = 'https://m.youshu.cc';
            npm_env = 'prod';
            wechat_id = isYzgx ? 206 : 5;
            appid = isYzgx ? 'wx801ff794f6a7c4d5' : 'wx17642efccac31518';
            pro_name = 'classroom_yz';
            scUrl = 'https://sc.youshu.cc';
            break;
        default:             //readoo生产环境
            //正式
            baseUrl = 'https://gongdu.youshu.cc';
            ys_baseUrl = 'https://readooapi.youshu.cc'; //生产环境上有书豆相关项目的域名
            baseUrlReadoo = 'https://readooapi.youshu.cc';  // 红包详情
            baseUrlstudy = 'https://gongdu.youshu.cc';
            order = 'https://gongdu.youshu.cc';
            hostUrl='https://m.youshu.cc';
            gxHostUrl = 'https://m.youshucs.com';
            readoo_host = 'https://lax.sanzijing.net'
            authorizationUrl='https://readooapi.youshu.cc';
            xlogUrl='https://xlog.youshu.cc';
            envId = 1;
            mobileLoginUrl = 'https://m.youshu.cc';
            npm_env = 'prod';
            wechat_id = isYzgx ? 206 : 5;
            appid = isYzgx ? 'wx801ff794f6a7c4d5' : 'wx17642efccac31518';
            pro_name = 'classroom_yz';
            scUrl = 'https://sc.youshu.cc';
            break;
    }
    routerMode = 'history'
}
if (isYzgx) pro_name = 'classroom_yzgx'
// console.log('isYzgx', isYzgx, pro_name, wechat_id, appid)

export {
	baseUrl,
    hostUrl,
    gxHostUrl,
    authorizationUrl,
    xlogUrl,
	routerMode,
	imgBaseUrl,
	wxjsurl,
    ys_baseUrl,
    baseUrlReadoo,
    order,
    baseUrlstudy,
    pro_name,
    envId,
    npm_env,
    readoo_host,
    wechat_id,
    appid,
    mobileLoginUrl,
    scUrl,
    isYzgx
}
